module.exports = __webpack_public_path__ + "img/model_17_ug.896c87f4.jpg";